import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Avatar, Box, Typography, Divider } from '@mui/material';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import Diversity1OutlinedIcon from '@mui/icons-material/Diversity1Outlined';
import PsychologyAltOutlinedIcon from '@mui/icons-material/PsychologyAltOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import AccountList from '../../menuitem/AccountList';
import AirIcon from '@mui/icons-material/Air';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import SupervisedUserCircleOutlinedIcon from '@mui/icons-material/SupervisedUserCircleOutlined';

import { useAuth0 } from '@auth0/auth0-react';
import ProjectContext from '../../../contexts/ProjectContext';
import UserContext from '../../../contexts/UserContext';
import FormContext from '../../../contexts/FormContext';
import ConfirmNavigationDialog from '../../dialog/ConfirmNavigationDialog';

export default function AccountContent(props) {
    const { avatar, handleClose, startTour } = props
    const { konsolUser } = useContext(UserContext)
    const { hasUnsavedChanges, setHasUnsavedChanges } = useContext(FormContext);
    const projectContext = useContext(ProjectContext)

    // confirmation dialog
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [pendingNavigation, setPendingNavigation] = useState(null);
    const navigate = useNavigate()


    const handleNavigation = (page) => {
        if (hasUnsavedChanges) {
            setPendingNavigation(page);
            setConfirmDialogOpen(true);
        } else {
            navigate(page);
            handleClose();
        }
    };

    const handleConfirmNavigation = () => {
        setConfirmDialogOpen(false);
        if (pendingNavigation) {
            navigate(pendingNavigation);
            handleClose();
            setPendingNavigation(null);
            setHasUnsavedChanges(false);
        }
    };

    const handleCancelNavigation = () => {
        setConfirmDialogOpen(false);
        setPendingNavigation(null);
    };

    const switchAccountSettings = () => {handleNavigation('/account')}
    const switchAccessSettings = () => {handleNavigation('/access')}
    const switchProduction = () => {handleNavigation('/production')}
    const switchAbout = () => {handleNavigation('/about')}
    const startTutorial = () => {handleNavigation()}

    const { logout } = useAuth0()

    function stringToColor(string) {
        let hash = 0;
        let i;
        for (i = 0; i < string.length; i += 1) {
          hash = string.charCodeAt(i) + ((hash << 5) - hash);
        }
        let color = '#';
        for (i = 0; i < 3; i += 1) {
          const value = (hash >> (i * 8)) & 0xff;
          color += `00${value.toString(16)}`.slice(-2);
        }
        return color;
    }


    const KonsolLogout = () => {
        logout({ logoutParams: {returnTo: process.env.REACT_APP_AUTH0_LOGOUT_URL}})
    }

    return (
        <React.Fragment>
            <div style={{ width: '260px', minWidth: '200px' }}>
                <Box
                    display="flex" 
                    flex-direction="row"
                    justifyContent="flex-start"
                    paddingBottom="16px">
                    <Box
                        paddingTop="4px"
                        paddingLeft="4px">
                        <Avatar 
                            sx={{   bgcolor: stringToColor(konsolUser?.name ?? ''),
                                    border: '2px solid #274333',
                                    fontSize: '15px',
                                    width: 35,
                                    height: 35
                            }}
                        >
                            {`${(konsolUser?.name?.[0] ?? 'X').toUpperCase()}${(konsolUser?.name?.[1] ?? 'X').toUpperCase()}`}
                        </Avatar>
                    </Box>
                    <Box paddingLeft="16px">
                        <Typography
                            variant="subtitle1"
                            fontWeight="bold"
                            sx={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                maxWidth: '190px', // Adjust the maxWidth as needed
                            }}
                        >
                            {konsolUser?.name}
                        </Typography>
                        <Typography 
                            variant="subtitle2"
                            sx={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                maxWidth: '190px', // Adjust the maxWidth as needed
                            }}
                        >
                            {(konsolUser?.project_roles ?? []).join(',')}
                        </Typography>
                    </Box>
                </Box>
                <Divider style={{ backgroundColor: '#575757' }}/>
                <Box paddingBottom="8px"></Box>
                <AccountList link={switchAccountSettings} label="Account Management" icon={<SettingsOutlinedIcon style={{ color: 'grey' }}/>} />
                <AccountList link={switchAccessSettings} label="Access Management" icon={<SupervisedUserCircleOutlinedIcon style={{ color: 'grey' }}/>} />
                <AccountList link={switchProduction} label="Workflow Document" icon={<AirIcon style={{ color: 'grey' }}/>} />
                <Box paddingBottom="8px"></Box>
                <Divider style={{ backgroundColor: '#575757' }}/>
                <Box paddingBottom="8px"></Box>

                <AccountList link={startTutorial} label="Tutorial" icon={<PsychologyAltOutlinedIcon style={{ color: 'grey' }}/>} />
                <AccountList link={switchAbout} label="About" icon={<InfoOutlinedIcon style={{ color: 'grey' }}/>} />
                <AccountList label="Sign Out" icon={<LogoutOutlinedIcon style={{ color: 'grey' }} />} link={KonsolLogout} />
            </div>

            <ConfirmNavigationDialog 
                open={confirmDialogOpen} 
                onClose={handleCancelNavigation} 
                onConfirm={handleConfirmNavigation}
                clickAway={handleCancelNavigation}
            />
        </React.Fragment>
    );
}